import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  CLEAR_FORGET_PASSWORD,
  RESET_FORGET_PASSWORD,
  RESET_FORGET_PASSWORD_SUCCESS,
  RESET_FORGET_PASSWORD_ERROR,
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

export const clearForgetPasswordState = () => {
  return {
    type: CLEAR_FORGET_PASSWORD,
  }
}

export const userResetForgetPassword = (user, history) => {
  return {
    type: RESET_FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userResetForgetPasswordSuccess = (message) => {
  return {
    type: RESET_FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userResetForgetPasswordError = (message) => {
  return {
    type: RESET_FORGET_PASSWORD_ERROR,
    payload: message,
  }
}
